import { h, Component } from 'preact';
import { Wizard } from '../../components/wizard';

export default class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        var me = this;
        me.state = {
            focuskey: '',
            success: false,
            email: '',
            emailValid: false,
            errMsg: '',
            errVisible: false,
            loading: false
        }

        document.addEventListener('keydown', function (e) {
            if (e.keyCode == 13) {
                document.getElementById('email').blur();
                me.submit(e);
            }
        });
    }

    componentDidMount() {
        if (!this.state.errVisible) {
            document.getElementById('email').focus();
        }
    }

    clearErr() {
        if (this.state.errMsg || this.state.errVisible) {
            this.setState((prevState, props) => ({
                errMsg: '',
                errVisible: false
            }));
        }
    }

    focus = e => {
        if (e.type == 'blur') {
            this.setState((prevState, props) => ({
                focuskey: ''
            }));
        } else {
            this.setState((prevState, props) => ({
                focuskey: e.target.getAttribute("id")
            }));
        }
    }

    hideErr = e => {
        this.setState((prevState, props) => ({
            errVisible: false,
        }));
        document.getElementById('email').select();
        document.getElementById('email').focus();
    }

    submit = (e) => {
        var me = this

        if (me.state.errVisible) {
            me.hideErr(e);
        } else if (me.state.errMsg) {
            me.setState((prevState, props) => ({
                errVisible: true
            }));
        }

        if (!me.validateEmail(me.state.email)) {
            me.setState((prevState, props) => ({
                emailValid: false
            }));
            document.getElementById('email').focus();
            return
        }

        if (me.validateEmail(me.state.email)) {
            let json = JSON.stringify({
                emailAddress: me.state.email,
            });

            // set loading state
            me.setState((prevState, props) => ({
                loading: true
            }));
            let logo = document.getElementsByClassName('logo-target')[0];
            logo.classList.add('loading');

            // Submit
            fetch('/api/v1/user/recover', {
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: json
            }).then(function (responseObj) {
                logo.classList.remove('loading');
                if (responseObj.status == 400 || responseObj.status == 500) {
                    me.setState((prevState, props) => ({
                        errMsg: <span>Unknown Error<br />Please contact Vigilant support.</span>,
                        errVisible: true,
                        loading: false,
                        email: ''
                    }));
                } else {
                    me.setState((prevState, props) => ({
                        success: true,
                        loading: false
                    }));
                }
            });
        }
    }

    redirectToLogin = () => {
        //route('/',true); //THIS DOES NOT WORK because we aren't using preact-router in the main.js yet
        location = '/';
    }

    updateEmail = e => {
        this.setState((prevState, props) => ({
            email: e.target.value,
            emailValid: this.validateEmail(e.target.value)
        }));
        this.clearErr();
    }

    validateEmail = email => {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    render(props, state) {
        var emailPlaceholderClasses = "floating-placeholder";
        if(state.focuskey == 'email') {
            emailPlaceholderClasses += ' float';
        }
        if (state.email != '') {
            emailPlaceholderClasses += ' hidden';
        }
        var submitClass = (state.emailValid) ? 'primed' : 'locked';
        submitClass = state.errMsg ? (state.errVisible ? 'error' : 'errHidden') : submitClass;
        submitClass = state.loading ? 'loading position-spin' : submitClass;

        var outlinerClass = state.focuskey ? 'email pw' : '';
        if (!state.emailValid && state.email != '') {
            outlinerClass += ' emailErr pwErr';
        }
        return (
            <div class="wizard passwordFormAligner">
                    {!state.success ? 
                    <span>
                    <div style="text-align:center;padding: 0 0 1em;font-size:1.2em;">
                        Enter your email address below to request a password reset.
                    </div>
                    <div id="passwordForm" style="margin-top:0;" class={state.loading?' loading':''}>
                        <div>
                            <div class={emailPlaceholderClasses}>
                                <input type="email" id="email" maxlength="320" value={state.email}
                                class={"large" + (state.emailValid || state.email == '' ? '' : ' error')}
                                onBlur={this.focus}
                                onFocus={this.focus}
                                onInput={this.updateEmail}
                                onChange={this.updateEmail}
                                style="text-align:left;font-size:24px;padding:10px 30px 10px 10px;"/>
                                <label for="email">Email</label>
                            </div>
                        </div>
                        <div id="errMsg" class={state.errVisible ? '' : 'hidden'}
                            onClick={this.hideErr}>
                            {state.errMsg}
                        </div>
                        <button type="button" onClick={this.submit}
                            class={"circle-form-button "+submitClass} />
                        <div id="input-outliner" class={outlinerClass} />
                    </div>
                    <div style="text-align:center;padding:1em;">
                        <a href="/">Back To Sign In</a>
                    </div>
                    </span> : 
                    <Wizard isPanel={true} 
                        title="Thank You" 
                        next={{callback: this.redirectToLogin, label: 'Sign In'}}>
                        <p style="text-align:center;margin:1em;">A password reset link has been sent to {state.email}.</p>
                    </Wizard>}
            </div>
        );
    }
}
